import ChannelSplit from './ChannelSplit';

export default (props) => <ChannelSplit {...props} />;
